export const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.palletcloud.io/";
export const appUrl = process.env.REACT_APP_APP_URL || 'https://www.palletcloud.io/';